const dev = {
  env: 'development',
  api: {
    TRAVEL_URL: "//localhost:5000",
    DOMAIN: "localhost"
  },
  stripe: {
    PRICING_TABLE_ID: process.env.REACT_APP_STRIPE_PRICING_TABLE_ID,
    API_KEY: process.env.REACT_APP_STRIPE_API_KEY,
  },
  ui: {
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    GOOGLE_MAPS_MAP_ID: process.env.REACT_APP_GOOGLE_MAPS_MAP_ID,
  },
};

const prod = {
  env: 'production',
  api: {
    TRAVEL_URL: "https://api.travelities.com",
    DOMAIN: ".travelities.com"
  },
  stripe: {
    PRICING_TABLE_ID: process.env.REACT_APP_STRIPE_PRICING_TABLE_ID,
    API_KEY: process.env.REACT_APP_STRIPE_API_KEY,
  },
  ui: {
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    GOOGLE_MAPS_MAP_ID: process.env.REACT_APP_GOOGLE_MAPS_MAP_ID,
  },
};

const staging = {
  env: 'staging',
  api: {
    TRAVEL_URL: "https://api-staging.travelities.com",
    DOMAIN: ".travelities.com"
  },
  stripe: {
    PRICING_TABLE_ID: process.env.REACT_APP_STRIPE_PRICING_TABLE_ID,
    API_KEY: process.env.REACT_APP_STRIPE_API_KEY,
  },
  ui: {
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    GOOGLE_MAPS_MAP_ID: process.env.REACT_APP_GOOGLE_MAPS_MAP_ID,
  },
};

export const config = process.env.REACT_APP_STAGE === 'production' ? prod : process.env.REACT_APP_STAGE === 'staging' ? staging : dev;